import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import application from "./modules/application";
import appConfig from "@/config/application";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";

const vuexPersist = new VuexPersist({
  key: appConfig.appKeyLocalStorage,
  storage: window.localStorage
});

export default new Vuex.Store({
  modules: {
    application
  },
  strict: debug,
  plugins: [vuexPersist.plugin]
});
